import { render, staticRenderFns } from "./RequestsIndex.vue?vue&type=template&id=0ea53de1&"
import script from "./RequestsIndex.vue?vue&type=script&lang=js&"
export * from "./RequestsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports